// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useEffect } from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import queryString from "query-string";
import { updateDrawer } from "../../modules/session";
import { AgentExperience } from "../../containers/app/agentExperience";
import { getLocation } from "@src/appV2/redesign/utils/routes";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function PrivateRoute(props: any) {
  const { isAuthorized, isAgent, pseudo, component: Component, componentProps, ...rest } = props;
  const location = useLocation();
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { userId, isLoggedOut } = useSelector((state: any) => state.session);
  const dispatch = useDispatch();

  useEffect(() => {
    const qs = queryString.parse(location.search);
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const { drawer, userId } = qs;

    if (!pseudo || !userId || !drawer) {
      return;
    }

    pseudo({ userId }).then(() =>
      drawer ? dispatch(updateDrawer({ option: true, type: drawer })) : null
    );
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // FIXME: Automatically disabled during ESLint config update
  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'props' implicitly has an 'any' type.
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const renderRoute = (props) => {
    if (!isAuthorized) {
      const enterLocation = getLocation("enter");
      // Only preserve the requested URL when the user has no session at all
      // (e.g. navigated directly to a protected page). We must NOT capture
      // the URL when the user is logged in but unauthorized for the current
      // route (e.g. admin viewing as agent) — that creates a redirect loop
      // via localStorage.redirectURL. After an explicit logout we also skip
      // capturing to avoid redirecting the next user to a stale page.
      if (!userId && !isLoggedOut) {
        const currentPath = `${location.pathname}${location.search}`;
        if (currentPath && currentPath !== "/") {
          // Cognito flows read the requestedUrl query param; localStorage
          // mirrors it as a belt-and-suspenders fallback for legacy
          // call sites still reading `redirectURL`.
          localStorage.setItem("redirectURL", currentPath);
          return (
            <Redirect
              to={{
                ...enterLocation,
                search: queryString.stringify({ requestedUrl: currentPath }),
              }}
            />
          );
        }
      }
      return <Redirect to={enterLocation} />;
    }
    const redirectURL = localStorage.getItem("redirectURL");

    if (redirectURL && userId) {
      const url = redirectURL;
      localStorage.removeItem("redirectURL");
      return <Redirect to={url} />;
    }

    if (isAgent) {
      return <AgentExperience />;
    }
    return <Component {...props} {...componentProps} />;
  };
  return <Route {...rest} render={renderRoute} />;
}
